"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var SvgLink = function SvgLink(props) {
  return React.createElement("svg", __assign({
    x: "0px",
    y: "0px",
    width: "1792px",
    height: "1792px",
    viewBox: "0 0 1792 1792",
    enableBackground: "new 0 0 1792 1792",
    xmlSpace: "preserve"
  }, props), React.createElement("g", {
    id: "Guide"
  }), React.createElement("g", {
    id: "Font",
    display: "none"
  }), React.createElement("g", {
    id: "\\u5185\\u5BB9"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M1543.609,519.916c0.051-0.052,0.104-0.101,0.156-0.152c74.98-74.98,74.98-196.547,0-271.527 c-74.981-74.981-196.548-74.982-271.53-0.001v0.001l-0.001-0.002L765.536,754.932C731.335,626.83,764.446,484.496,864.942,384 l271.529-271.529c149.96-149.961,393.096-149.961,543.058,0c149.961,149.961,149.961,393.098,0,543.059L1408,927.059 c-100.497,100.498-242.834,133.608-370.938,99.404L1543.609,519.916z"
  }), React.createElement("path", {
    d: "M112.47,1136.471L384,864.941c100.496-100.497,242.83-133.607,370.933-99.405l-330.226,330.226l0.001,0.001 l-176.473,176.473c-74.98,74.981-74.98,196.548,0,271.528c74.981,74.981,196.548,74.981,271.529,0l271.528-271.529v-0.001 l235.17-235.17c34.203,128.103,1.091,270.439-99.405,370.937l-271.53,271.529c-149.96,149.961-393.095,149.961-543.056,0 C-37.49,1529.567-37.49,1286.432,112.47,1136.471z"
  }), React.createElement("path", {
    d: "M1061.49,549.49c23.164-23.163,55.164-37.49,90.51-37.49c70.692,0,128,57.308,128,128c0,35.346-14.327,67.346-37.49,90.51 l-511.779,511.779l-0.004-0.003C707.547,1265.58,675.459,1280,640,1280c-70.693,0-128-57.308-128-128 c0-36.001,14.868-68.525,38.793-91.782l-0.015-0.016L1061.49,549.49z"
  }))), React.createElement("g", {
    id: "\\u30E9\\u30D9\\u30EB"
  }), React.createElement("g", {
    id: "Unicode",
    display: "none"
  }, React.createElement("text", {
    transform: "matrix(1 0 0 1 437.0635 964.2812)",
    display: "inline",
    fill: "#ED1E79",
    fontFamily: "'ArialMT'",
    fontSize: 256
  }, "U+F724")));
};
exports.default = SvgLink;